import Bugsnag from '@bugsnag/js';

let sequence = 0;
export const nextCheckoutAttempt = () => {
  sequence += 1;
  return `checkout-${sequence}`;
};
export function checkoutProgress(stage, attemptId, outcome) {
  // Fixed vocabulary and process-local correlation only: never payloads/keys.
  Bugsnag.leaveBreadcrumb(
    'checkout progress',
    {
      stage,
      attemptId,
      outcome,
    },
    'state'
  );
}
